module.exports = __webpack_public_path__ + "img/symbol_0.fde724df.png";